module.exports = __webpack_public_path__ + "static/img/del.a3b2823.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/del.jpeg
// module id = GLcK
// module chunks = 1